import { SuppliesTrackableProductType } from "@redotech/cockroachdb-codegen/tables/product/supplies-trackable-product-type";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const getSuppliesTrackableProducts = {
  name: "getSuppliesTrackableProducts" as const,
  input: z.object({}),
  output: z.object({
    products: z.array(
      z.object({
        suppliesProductId: productIdFormat.schema,
        title: z.string(),
        type: z.enum(SuppliesTrackableProductType),
        unitsPerCase: z.number().int(),
        imageUrl: z.string().nullish(),
      }),
    ),
  }),
};
